import Types from '../types';

const minimizeSidebar = payload => ({
  type: Types.MINIMIZE_SIDEBAR,
  payload,
});

export default minimizeSidebar;
